import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../wayfinder'
/**
* @see \App\Http\Controllers\RentalUnitController::index
* @see app/Http/Controllers/RentalUnitController.php:15
* @route '//app.finesthub.de/properties/{estateObject}/rental-units'
*/
export const index = (args: { estateObject: string | number } | [estateObject: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(args, options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: '//app.finesthub.de/properties/{estateObject}/rental-units',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\RentalUnitController::index
* @see app/Http/Controllers/RentalUnitController.php:15
* @route '//app.finesthub.de/properties/{estateObject}/rental-units'
*/
index.url = (args: { estateObject: string | number } | [estateObject: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { estateObject: args }
    }

    if (Array.isArray(args)) {
        args = {
            estateObject: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        estateObject: args.estateObject,
    }

    return index.definition.url
            .replace('{estateObject}', parsedArgs.estateObject.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\RentalUnitController::index
* @see app/Http/Controllers/RentalUnitController.php:15
* @route '//app.finesthub.de/properties/{estateObject}/rental-units'
*/
index.get = (args: { estateObject: string | number } | [estateObject: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\RentalUnitController::index
* @see app/Http/Controllers/RentalUnitController.php:15
* @route '//app.finesthub.de/properties/{estateObject}/rental-units'
*/
index.head = (args: { estateObject: string | number } | [estateObject: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\RentalUnitController::store
* @see app/Http/Controllers/RentalUnitController.php:20
* @route '//app.finesthub.de/properties/{estateObject}/rental-units'
*/
export const store = (args: { estateObject: string | number | { id: string | number } } | [estateObject: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(args, options),
    method: 'post',
})

store.definition = {
    methods: ["post"],
    url: '//app.finesthub.de/properties/{estateObject}/rental-units',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\RentalUnitController::store
* @see app/Http/Controllers/RentalUnitController.php:20
* @route '//app.finesthub.de/properties/{estateObject}/rental-units'
*/
store.url = (args: { estateObject: string | number | { id: string | number } } | [estateObject: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { estateObject: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { estateObject: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            estateObject: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        estateObject: typeof args.estateObject === 'object'
        ? args.estateObject.id
        : args.estateObject,
    }

    return store.definition.url
            .replace('{estateObject}', parsedArgs.estateObject.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\RentalUnitController::store
* @see app/Http/Controllers/RentalUnitController.php:20
* @route '//app.finesthub.de/properties/{estateObject}/rental-units'
*/
store.post = (args: { estateObject: string | number | { id: string | number } } | [estateObject: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\RentalUnitController::update
* @see app/Http/Controllers/RentalUnitController.php:31
* @route '//app.finesthub.de/properties/{estateObject}/rental-units/{rental_unit}'
*/
export const update = (args: { estateObject: string | number | { id: string | number }, rental_unit: string | number | { id: string | number } } | [estateObject: string | number | { id: string | number }, rental_unit: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

update.definition = {
    methods: ["put","patch"],
    url: '//app.finesthub.de/properties/{estateObject}/rental-units/{rental_unit}',
} satisfies RouteDefinition<["put","patch"]>

/**
* @see \App\Http\Controllers\RentalUnitController::update
* @see app/Http/Controllers/RentalUnitController.php:31
* @route '//app.finesthub.de/properties/{estateObject}/rental-units/{rental_unit}'
*/
update.url = (args: { estateObject: string | number | { id: string | number }, rental_unit: string | number | { id: string | number } } | [estateObject: string | number | { id: string | number }, rental_unit: string | number | { id: string | number } ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            estateObject: args[0],
            rental_unit: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        estateObject: typeof args.estateObject === 'object'
        ? args.estateObject.id
        : args.estateObject,
        rental_unit: typeof args.rental_unit === 'object'
        ? args.rental_unit.id
        : args.rental_unit,
    }

    return update.definition.url
            .replace('{estateObject}', parsedArgs.estateObject.toString())
            .replace('{rental_unit}', parsedArgs.rental_unit.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\RentalUnitController::update
* @see app/Http/Controllers/RentalUnitController.php:31
* @route '//app.finesthub.de/properties/{estateObject}/rental-units/{rental_unit}'
*/
update.put = (args: { estateObject: string | number | { id: string | number }, rental_unit: string | number | { id: string | number } } | [estateObject: string | number | { id: string | number }, rental_unit: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

/**
* @see \App\Http\Controllers\RentalUnitController::update
* @see app/Http/Controllers/RentalUnitController.php:31
* @route '//app.finesthub.de/properties/{estateObject}/rental-units/{rental_unit}'
*/
update.patch = (args: { estateObject: string | number | { id: string | number }, rental_unit: string | number | { id: string | number } } | [estateObject: string | number | { id: string | number }, rental_unit: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'patch'> => ({
    url: update.url(args, options),
    method: 'patch',
})

/**
* @see \App\Http\Controllers\RentalUnitController::destroy
* @see app/Http/Controllers/RentalUnitController.php:42
* @route '//app.finesthub.de/properties/{estateObject}/rental-units/{rental_unit}'
*/
export const destroy = (args: { estateObject: string | number | { id: string | number }, rental_unit: string | number | { id: string | number } } | [estateObject: string | number | { id: string | number }, rental_unit: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

destroy.definition = {
    methods: ["delete"],
    url: '//app.finesthub.de/properties/{estateObject}/rental-units/{rental_unit}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\RentalUnitController::destroy
* @see app/Http/Controllers/RentalUnitController.php:42
* @route '//app.finesthub.de/properties/{estateObject}/rental-units/{rental_unit}'
*/
destroy.url = (args: { estateObject: string | number | { id: string | number }, rental_unit: string | number | { id: string | number } } | [estateObject: string | number | { id: string | number }, rental_unit: string | number | { id: string | number } ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            estateObject: args[0],
            rental_unit: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        estateObject: typeof args.estateObject === 'object'
        ? args.estateObject.id
        : args.estateObject,
        rental_unit: typeof args.rental_unit === 'object'
        ? args.rental_unit.id
        : args.rental_unit,
    }

    return destroy.definition.url
            .replace('{estateObject}', parsedArgs.estateObject.toString())
            .replace('{rental_unit}', parsedArgs.rental_unit.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\RentalUnitController::destroy
* @see app/Http/Controllers/RentalUnitController.php:42
* @route '//app.finesthub.de/properties/{estateObject}/rental-units/{rental_unit}'
*/
destroy.delete = (args: { estateObject: string | number | { id: string | number }, rental_unit: string | number | { id: string | number } } | [estateObject: string | number | { id: string | number }, rental_unit: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

const RentalUnitController = { index, store, update, destroy }

export default RentalUnitController